export default "__VITE_ASSET__CVSlc0rl__"